import React from "react";
import { CardContent, CardTitle } from "properties/propertyCard/components/PropertyCardComponents";
import { PropertyCardTitle } from "properties/propertyCard/components/PropertyCardTitle";
import { TCommunityCard } from "admin/communities/_models/CommunitiesMdl";
import { CommunityCardInfosDetails } from "communities/community-page/_components/card/community-card-infos-details";
import { CommunityCardGeozone } from "communities/community-page/_components/card/community-card-geozone";
import { observer } from "mobx-react-lite";
import house from "../../../../assets/images/communities/house.svg";
import doubleHouse from "../../../../assets/images/communities/doubleHouse.svg";
import square from "../../../../assets/images/icons/square.svg";

type Props = {
    community: TCommunityCard;
};

export const CommunityCardInfos = observer(({ community }: Props) => {
    return (
        <>
            <div className={"mb-2.5"}>
                <CardTitle>
                    <PropertyCardTitle title={community.localized.title} />
                </CardTitle>
            </div>
            <div className={"mb-2.5"}>
                <CardContent className={"mb-2.5"}>
                    <div className="flex flex-wrap gap-2">
                        <CommunityCardInfosDetails
                            icon={house}
                            count={community.propertiesCount ?? 0}
                            translate={"communitiesPage.propertiesSale"}
                        />
                        <CommunityCardInfosDetails
                            icon={doubleHouse}
                            count={community.unitsCount ?? 0}
                            translate={"communitiesPage.unitsSale"}
                        />
                        <CommunityCardInfosDetails
                            icon={square}
                            count={community.totalSurface ?? 0}
                            translate={"communitiesPage.totalSurface"}
                        />
                    </div>
                </CardContent>
                <CommunityCardGeozone
                    geoZoneId={community.geoZoneId}
                    geoZone={{
                        city: community.geoZone?.address.city ?? "",
                        neighbourhood: community.geoZone?.address.neighbourhood ?? "",
                        provinceLong: community.geoZone?.address.provinceLong ?? "",
                    }}
                />
            </div>
        </>
    );
});
